import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';


// Simulated API call to fetch messages (use an actual API in production)
const fetchMessages = async () => {
    // Simulating API delay
    const response = await new Promise((resolve) =>
        setTimeout(() => {
            resolve([
                { sender: 'John Doe', text: 'Hey, how\'s it going?', time: '2 mins ago' },
                { sender: 'You', text: 'I\'m doing well, thanks for asking!', time: '1 min ago' },
                { sender: 'John Doe', text: 'That\'s awesome! What have you been up to?', time: '1 min ago' },
            ]);
        }, 1000)
    );
    return response;
};
const users = [
    { name: 'John Doe', lastMessageTime: '2 mins ago', imageUrl: './logo192.png' },
    { name: 'Jane Smith', lastMessageTime: '10 mins ago', imageUrl: './logo192.png' },
    { name: 'Mark Wilson', lastMessageTime: '30 mins ago', imageUrl: './logo192.png' },
    { name: 'Alice Cooper', lastMessageTime: '1 hour ago', imageUrl: './logo192.png' }
  ];

  const Sidebar = () => (
    <div className="card shadow-sm rounded h-100">
        <div className="card-header">
            <h5>Chats</h5>
        </div>
        <div className="list-group list-group-flush">
            {users.map((user, index) => (
                <a href="#" className="list-group-item list-group-item-action d-flex align-items-center" key={index}>
                    <img src={user.imageUrl} alt={user.name} className="rounded-circle me-2" style={{ width: '40px', height: '40px' }} />
                    <div className="d-flex justify-content-between w-100">
                        <div>
                            <strong>{user.name}</strong>
                            <br />
                            <small className="text-muted">{user.lastMessageTime}</small>
                        </div>
                        <div className="text-end">
                            <i className="bx bx-chat" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                    </div>
                </a>
            ))}
        </div>
    </div>
);


const ChatMessage = ({ sender, text, time }) => (
    <div className={`d-flex mb-3  ${sender === 'You' ? 'justify-content-end' : ''}`}>
        {sender !== 'You' && (
            <div className="mr-3">
                <img src="./logo192.png" className="rounded-circle " alt="user" style={{ width: '40px', height: '40px' }} />
            </div>
        )}
        <div className={`message-bubble ${sender === 'You' ? 'bg-primary text-white' : 'bg-light'}`}>
            <p className="mb-0"><strong>{sender}</strong></p>
            <p className="mb-0">{text}</p>
            <small className="text-muted">{time}</small>
        </div>
        {sender === 'You' && (
            <div className="ml-3">
                <img src="./logo192.png" className="rounded-circle" alt="user" style={{ width: '40px', height: '40px' }}/>
            </div>
        )}
    </div>
);

const ChatInput = ({ newMessage, setNewMessage, sendMessage }) => (
    <div className="card-footer border-0 bg-light">
        <form className="form-inline d-flex" onSubmit={sendMessage}>
            <input
                type="text"
                className="form-control rounded-pill"
                placeholder="Type a message..."
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                style={{ flexGrow: 1 }}
            />
            <button type="submit" className="btn btn-primary rounded-pill ms-2">
                Send
            </button>
        </form>
    </div>
);

const ChatHeader = ({ userName }) => (
    <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
            <img src="./logo192.png" className="rounded-circle me-2" alt="user" style={{height:'40px',width:'40px'}}/>
            <h5>{userName}</h5>
        </div>
        <button className="btn btn-outline-light">Profile</button>
    </div>
);

const Chat = () => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');

    useEffect(() => {
        // Fetch messages when component mounts
        const getMessages = async () => {
            const data = await fetchMessages();
            setMessages(data);
        };
        getMessages();
    }, []);

    const sendMessage = (e) => {
        e.preventDefault();
        if (newMessage.trim()) {
            setMessages([
                ...messages,
                { sender: 'You', text: newMessage, time: 'Just now' }
            ]);
            setNewMessage('');
        }
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                {/*breadcrumb*/}
                <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                    <div className="breadcrumb-title pe-3">Chat List</div>
                    <div className="ps-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 p-0">
                                <li className="breadcrumb-item">
                                    <a href="javascript:;">
                                        <i className="bx bx-home-alt" />
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Chat Table
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="ms-auto">
                        <div className="btn-group">
                            <button type="button" className="btn btn-primary">
                                Settings
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary split-bg-primary dropdown-toggle dropdown-toggle-split"
                                data-bs-toggle="dropdown"
                            >
                                {" "}
                                <span className="visually-hidden">Toggle Dropdown</span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-right dropdown-menu-lg-end">
                                {" "}
                                <a className="dropdown-item" href="javascript:;">
                                    Action
                                </a>
                                <a className="dropdown-item" href="javascript:;">
                                    Another action
                                </a>
                                <a className="dropdown-item" href="javascript:;">
                                    Something else here
                                </a>
                                <div className="dropdown-divider" />{" "}
                                <a className="dropdown-item" href="javascript:;">
                                    Separated link
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*end breadcrumb*/}
                <h6 className="mb-0 text-uppercase">Category List</h6>
                <hr />
                <button
                    type="button"
                    onClick={''}
                    className="btn btn-primary mb-2"
                > 
                    Chat view
                </button>

        <div className="d-flex">
            {/* Sidebar */}
            <div className="col-md-4 col-lg-3">
                <Sidebar />
            </div>

            {/* Chat window */}
            <div className="col-md-8 col-lg-9">
                <div className="card shadow-lg">
                    <ChatHeader userName="John Doe" />
                    <div className="card-body" style={{ maxHeight: '400px', overflowY: 'fix' }}>
                        {/* Render chat messages */}
                        {messages.map((msg, index) => (
                            <ChatMessage
                                key={index}
                                sender={msg.sender}
                                text={msg.text}
                                time={msg.time}
                            />
                        ))}
                    </div>
                    <ChatInput newMessage={newMessage} setNewMessage={setNewMessage} sendMessage={sendMessage} />
                </div>
            </div>
        </div>
        </div></div>
    );
};

export default Chat;
